import { render, staticRenderFns } from "./TaskTemplateNewForm.vue?vue&type=template&id=11472e70"
import script from "./TaskTemplateNewForm.vue?vue&type=script&lang=js"
export * from "./TaskTemplateNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports